import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { GC_MODES } from '@pixi/constants';
import { settings } from '@pixi/settings';
import { ExtensionType, extensions } from '@pixi/extensions';
var TextureGCSystem = /*#__PURE__*/function () {
  function TextureGCSystem(renderer) {
    _classCallCheck(this, TextureGCSystem);
    this.renderer = renderer;
    this.count = 0;
    this.checkCount = 0;
    this.maxIdle = settings.GC_MAX_IDLE;
    this.checkCountMax = settings.GC_MAX_CHECK_COUNT;
    this.mode = settings.GC_MODE;
  }
  _createClass(TextureGCSystem, [{
    key: "postrender",
    value: function postrender() {
      if (!this.renderer.objectRenderer.renderingToScreen) {
        return;
      }
      this.count++;
      if (this.mode === GC_MODES.MANUAL) {
        return;
      }
      this.checkCount++;
      if (this.checkCount > this.checkCountMax) {
        this.checkCount = 0;
        this.run();
      }
    }
  }, {
    key: "run",
    value: function run() {
      var tm = this.renderer.texture;
      var managedTextures = tm.managedTextures;
      var wasRemoved = false;
      for (var i = 0; i < managedTextures.length; i++) {
        var texture = managedTextures[i];
        if (!texture.framebuffer && this.count - texture.touched > this.maxIdle) {
          tm.destroyTexture(texture, true);
          managedTextures[i] = null;
          wasRemoved = true;
        }
      }
      if (wasRemoved) {
        var j = 0;
        for (var _i = 0; _i < managedTextures.length; _i++) {
          if (managedTextures[_i] !== null) {
            managedTextures[j++] = managedTextures[_i];
          }
        }
        managedTextures.length = j;
      }
    }
  }, {
    key: "unload",
    value: function unload(displayObject) {
      var tm = this.renderer.texture;
      var texture = displayObject._texture;
      if (texture && !texture.framebuffer) {
        tm.destroyTexture(texture);
      }
      for (var i = displayObject.children.length - 1; i >= 0; i--) {
        this.unload(displayObject.children[i]);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.renderer = null;
    }
  }]);
  return TextureGCSystem;
}();
TextureGCSystem.extension = {
  type: ExtensionType.RendererSystem,
  name: "textureGC"
};
extensions.add(TextureGCSystem);
export { TextureGCSystem };